import Request from ".";
import { Routes } from "../constant/api_url";

const insertCustomerApi = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCUSTOMER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateCustomerApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECUSTOMER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getCustomerApi = async () => {
  try {
    const result = await Request.get(Routes.GETCUSTOMERS);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteCustomerApi = async (data) => {
  try {
    const result = await Request.delete(Routes.DELETECUSTOMER, { data });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export { insertCustomerApi, updateCustomerApi, getCustomerApi, deleteCustomerApi };
